module.exports = __webpack_public_path__ + "static/media/1.21e34495.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/1.png
 ** module id = 193
 ** module chunks = 0
 **/